const industries = [
  {
    id: 'retail',
    label: 'Retail',
    headline: 'In-Store & Online.\nUnified.',
    description: 'From flagship stores to pop-up locations — accept payments anywhere with unified reporting that actually makes sense.',
    features: ['POS Integration', 'Mobile Payments', 'Inventory Sync', 'Loyalty Programs'],
    image: '/images/sol-ind-retail-01.jpg',
  },
  {
    id: 'hospitality',
    label: 'Hospitality',
    headline: 'Built for\nThe Pace of Service.',
    description: 'Tableside payments, split checks, and tip management that keeps your staff moving and your guests happy.',
    features: ['Tableside Ordering', 'Split Checks', 'Tip Management', 'Room Charge'],
    image: '/images/sol-ind-hosp-01.jpg',
  },
  {
    id: 'ecommerce',
    label: 'E-Commerce',
    headline: 'Commerce\nWithout Compromise.',
    description: 'Checkout flows, subscription billing, and fraud prevention engineered for conversion — not just compliance.',
    features: ['One-Click Checkout', 'Subscription Billing', 'Global Payments', 'Cart Recovery'],
    image: '/images/sol-ind-ecom-01.jpg',
  },
  {
    id: 'enterprise',
    label: 'Enterprise',
    headline: 'Infrastructure\nAt Scale.',
    description: 'Multi-entity reconciliation, custom routing logic, and dedicated support for organizations that cannot afford downtime.',
    features: ['Multi-Entity Support', 'Custom Routing', 'Dedicated Account Team', 'SLA Guarantees'],
    image: '/images/sol-ind-ent-01.jpg',
  },
];

export default function IndustryBreakdown() {
  return (
    <section className="bg-[#F9F9F7] py-28 px-5 md:px-[75px]">
      <div className="max-w-[1400px] mx-auto">
        {/* Section Header */}
        <div className="mb-20">
          <p
            className="text-[#a8894a] text-[10px] uppercase tracking-[0.25em] font-medium mb-5"
            style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
          >
            By Industry
          </p>
          <h2
            className="text-[#061e45] text-4xl md:text-5xl lg:text-[54px] font-light leading-[1.1] max-w-2xl"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Tailored to Your Business Model.
          </h2>
        </div>

        {/* Industry Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#1A1A1A]/10">
          {industries.map((ind) => (
            <div key={ind.id} className="bg-[#F9F9F7] hover:bg-white group transition-colors duration-300">
              {/* Image */}
              <div className="w-full h-56 overflow-hidden">
                <img
                  src={ind.image}
                  alt={ind.label}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-10">
                <span
                  className="text-[#a8894a] text-[10px] uppercase tracking-[0.2em] mb-4 block"
                  style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
                >
                  {ind.label}
                </span>
                <h3
                  className="text-[#061e45] text-2xl md:text-3xl font-light leading-snug mb-4 whitespace-pre-line"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {ind.headline}
                </h3>
                <p
                  className="text-[#1A1A1A]/55 text-[15px] leading-relaxed mb-8"
                  style={{ fontFamily: "'Google Sans Flex', sans-serif", fontWeight: 400 }}
                >
                  {ind.description}
                </p>

                {/* Features */}
                <div className="flex flex-wrap gap-2">
                  {ind.features.map((feature) => (
                    <span
                      key={feature}
                      className="text-[#1A1A1A]/40 text-[10px] uppercase tracking-[0.12em] px-3 py-1.5 border border-[#1A1A1A]/12"
                      style={{ fontFamily: "'Google Sans Flex', sans-serif" }}
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}